<!--
  @Description: 
  @Author: wang.y 
  @Date: 2025-03-26 
-->
<template>
  <Modal class="download-modal" title="导出" v-model="visible" footer-hide width="550px">
    <div class="modal-warpper">
      <!-- 导出方式 -->
      <div class="export-section">
        <div class="section-title">Export Method</div>
        <div class="export-options">
          <RadioGroup v-model="exportType" @on-change="getModuleList">
            <Radio :label="1">Export by Issue (Multi-selectable)</Radio>
            <Radio :label="2">Export by Release Date</Radio>
          </RadioGroup>
          <div class="option" v-show="exportType === 1">
            <Select v-model="chapterIds" :max-tag-count="1" multiple @on-change="getModuleList">
              <Option v-for="item in chapterList" :value="item.id" :key="item.id">No.{{item.num}} {{item.enTitle}}</Option>
            </Select>
          </div>
          <div class="option" v-show="exportType === 2">
            <DatePicker v-model="dateRange" class="date-range" type="daterange" placeholder="Select Date Range" format="yyyy-MM-dd" @on-change="getModuleList"></DatePicker>
          </div>
        </div>
      </div>
      <!-- 按栏目 -->
      <div class="export-section" v-if="categories.length">
        <div class="section-title">By Category</div>
        <div class="category-options">
          <CheckboxGroup v-model="selectedCategories">
            <Checkbox :label="item.id" v-for="item in categories" :key="item.id" :disabled="selectedCategories.length == 1 && selectedCategories[0] == item.id">{{item.enName}}</Checkbox>
          </CheckboxGroup>
        </div>
      </div>

      <!-- 导出按钮 -->
      <div class="export-button">
        <Button type="primary" @click="handleExport" :disabled="categories.length == 0">Export Excel</Button>
      </div>
    </div>
  </Modal>
</template>
<script>
import { AchapterModuleList } from '@/service'
import moment from 'moment'
import axios from 'axios'
import md5 from 'md5'
const crc32 = function (r) {
  for (var a, o = [], c = 0; c < 256; c++) {
    a = c
    for (var f = 0; f < 8; f++) a = 1 & a ? 3988292384 ^ (a >>> 1) : a >>> 1
    o[c] = a
  }
  for (var n = -1, t = 0; t < r.length; t++) n = (n >>> 8) ^ o[255 & (n ^ r.charCodeAt(t))]
  return (-1 ^ n) >>> 0
}
export default {
  props: {
    chapterList: {
      default: () => [],
    },
    detailTitle: {
      default: '',
    },
  },
  data() {
    return {
      visible: false,
      dateRange: [],
      categories: [],
      exportType: 1, // 1: 按期数导出, 2: 按时间导出
      chapterIds: [],
      selectedCategories: [],
    }
  },
  methods: {
    show(defaultChapterIds) {
      this.dateRange = []
      this.categories = []
      this.exportType = 1
      this.chapterIds = [...defaultChapterIds]
      this.selectedCategories = []
      this.getModuleList()
      this.visible = true
    },
    handleExport() {
      // 处理导出逻辑
      if (this.exportType === 1 && !this.chapterIds.length) {
        this.$Message.error('Please Select Journal')
        return
      }
      if (this.exportType === 2 && (!this.dateRange.length || !this.dateRange[0])) {
        this.$Message.error('Please Select Date')
        return
      }
      const params = {
        chapterIds:
          this.exportType == 1 ? this.chapterIds : this.chapterList.map((item) => item.id),
        startTime:
          this.exportType == 2 ? moment(this.dateRange[0]).format('YYYY-MM-DD 00:00:00') : '',
        endTime:
          this.exportType == 2 ? moment(this.dateRange[1]).format('YYYY-MM-DD 23:59:59') : '',
        moduleIds: this.selectedCategories,
      }
      const timestamp_org = Math.trunc(new Date().getTime() / 1000)
      const timestamp_crc = String(crc32(String(timestamp_org))).substring(0, 3)
      const timestamp = Number(timestamp_org + timestamp_crc)
      const sign = JSON.stringify(params) + timestamp
      axios
        .post(
          this.$store.state.req_url3 + '/api/report/downloadChapterModuleContentList',
          JSON.stringify(params),
          {
            headers: {
              'content-Type': 'application/json; charset=UTF-8',
              timestamp: timestamp,
              sign: md5(sign),
            },
            responseType: 'blob',
          }
        )
        .then((response) => {
          this.exportParams(response)
        })
        .catch((error) => {
          console.error(error)
          this.$Message.error(error)
        })
    },
    exportParams(url) {
      const aLink = document.createElement('a')
      const blob = new Blob([url.data], {
        type: 'application/vnd.ms-excel',
      })
      // 创建一个当前文件的内存URL
      const _href = URL.createObjectURL(blob)
      aLink.style.display = 'none'
      aLink.href = _href
      document.body.appendChild(aLink)
      aLink.setAttribute(
        'download',
        this.detailTitle + '_data_' + moment().format('YYYYMMDDHHmmss') + '.xlsx'
      )
      aLink.click()
      document.body.removeChild(aLink)
      // 手动释放创建的URL对象所占内存
      URL.revokeObjectURL(_href)

      this.$nextTick(() => {
        this.$Message.success('Export Success')
        this.visible = false
      })
    },
    async getModuleList() {
      if (this.exportType === 1 && !this.chapterIds.length) {
        this.categories = []
        return
      }
      if (this.exportType === 2 && (!this.dateRange.length || !this.dateRange[0])) {
        this.categories = []
        return
      }
      const params = {
        startTime:
          this.exportType == 2 ? moment(this.dateRange[0]).format('YYYY-MM-DD 00:00:00') : '',
        endTime:
          this.exportType == 2 ? moment(this.dateRange[1]).format('YYYY-MM-DD 23:59:59') : '',
        chapterIds:
          this.exportType == 1 ? this.chapterIds : this.chapterList.map((item) => item.id),
      }
      let res = await AchapterModuleList(params, (error) => this.$Message.error('Request Error!'))
      if (res.code === 0) {
        this.$set(this.$data, 'categories', res.data.moduleList)
        this.selectedCategories = this.categories.map((item) => item.id)
      } else {
        this.$Message.error(res.enMsg)
      }
    },
  },
}
</script>
<style lang="stylus" scoped>
@import '../style/downloadModal.styl'
</style>